const partnerAreas = [
  'NG', // Nottingham
  'LE', // Leicester
  'YO', // York
  'LS', // Leeds
  'HU', // Hull
  'S', // Sheffield
  'OX', // Oxford
  'NE', // Newcastle
  'DH', // Durham
  'BS', // Bristol
  'BA', // Bath
  'CF', // Cardiff
  'EH', // Edinburgh
  'G', // Glasgow
  'EX', // Exeter
  'CB', // Cambridge
];

export function isOutOfArea(postcode: string) {
  let outOfArea = true;

  for (const area of partnerAreas) {
    const regex = new RegExp('^' + area + '\\d');

    if (regex.test(postcode)) {
      outOfArea = false;
    }
  }

  return outOfArea;
}

export function isDifferentArea(...postcodes: string[]) {
  let area: string | undefined;

  for (const postcode of postcodes) {
    const result = postcode.match(/[a-zA-Z]+(?=\d)/);

    if (result) {
      if (area && area !== result[0]) {
        return true;
      }

      area = result[0];
    }
  }

  return false;
}
